'use client';

import Image from '@components/common/ImageFallback';
import BannerImage from '@root/src/assets/images/banner_trang_san_pham_tra.png';

interface ProductPageHeaderProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}

export default function ProductPageHeader({
  title,
  subtitle,
  backgroundImage,
}: ProductPageHeaderProps) {
  const headerImage = backgroundImage || BannerImage;

  return (
    <div className="relative w-full overflow-hidden bg-[#F5EEE0] min-h-[220px] md:min-h-[280px]">
      {headerImage && (
        <Image
          src={headerImage}
          alt={title}
          fill
          className="object-cover"
          priority
        />
      )}

      {/* Decorative leaf elements */}
      <div className="absolute top-4 left-4 opacity-20 text-[#223A27]">
        <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17 8C8 10 5.9 16.17 3.82 19.5 3.67 20.18 3.85 21 4.82 21 10 21 20 17 20 7c0-.83-.36-1-1-1z"/>
        </svg>
      </div>
      <div className="absolute bottom-4 right-1/3 opacity-10 text-[#223A27]">
        <svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17 8C8 10 5.9 16.17 3.82 19.5 3.67 20.18 3.85 21 4.82 21 10 21 20 17 20 7c0-.83-.36-1-1-1z"/>
        </svg>
      </div>
    </div>
  );
}